import { Tab as MUITab, Tabs as MUITabs } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { BLACK, BLACK2, BORDER_GRAY, ICON_SECONDARY } from '../../theme';

export const Tabs = styled(MUITabs)`
  min-height: unset;
  overflow: unset;
  box-shadow: 0px -1px 0px 0px ${BORDER_GRAY} inset;

  .MuiTab-root {
    color: ${ICON_SECONDARY};
    padding: 6px 12px;
  }

  .MuiTab-root.Mui-selected {
    color: ${BLACK2};
  }

  .MuiTabs-indicator {
    background-color: ${BLACK};
  }
`;

export const TabPanels = styled.div`
  overflow-y: auto;
  margin-right: -8px;
  padding-right: 8px;
`;

interface TabPanelProps extends React.PropsWithChildren {
  index: number;
  tabs: string;
  value: number;
  conditionalRendering?: boolean;
}

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  index,
  tabs,
  value,
  conditionalRendering = true,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`${tabs}-tabpanel-${index}`}
    aria-labelledby={`${tabs}-tab-${index}`}
    {...other}
  >
    {(!conditionalRendering || value === index) && children}
  </div>
);

type TabProps = {
  index: number;
  label: string;
  tabs: string;
  onClick?: () => void;
};

// TODO: We should move away from MUI altogether in the next iteration
// https://github.com/teamexos/prince-web/pull/1090#pullrequestreview-1251612716
export const Tab = styled(({ index, tabs, onClick, ...props }: TabProps) => (
  <MUITab
    {...props}
    aria-controls={`${tabs}-tabpanel-${index}`}
    disableRipple
    id={`${tabs}-tab-${index}`}
    onClick={onClick}
  />
))`
  font-family: 'sharp' !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  min-width: unset !important;
  text-transform: none !important;
`;
